module.exports = __webpack_public_path__ + "static/builtworlds-333109127b613af79f1d109dc13dbadf.jpg";